// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  text: 'Este site utiliza cookies',
  link: {
    text: 'Leia nossa política de privacidade',
    label: 'Clique aqui para ler nossa política de privacidade',
  },
  btn: {
    text: 'Eu concordo',
    label: 'Eu concordo com a política de privacidade e autorizo o uso de cookies',
  },
} as ILanguage;
